export default id => ({
  type: 'HOVERED_NODE/SET',
  payload: id
});
